import { render } from "./Lucky.vue?vue&type=template&id=054bf94c"
import script from "./Lucky.vue?vue&type=script&lang=js"
export * from "./Lucky.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__